import { jsx as _jsx } from "react/jsx-runtime";
import { Home } from 'lucide-react';
/**
 * Topbar trail for every non-record Growth page (GRW-01): hub, Growth Home,
 * Pursuits list, workspace lists, landscape seats. Pass the result to
 * `useRecordBreadcrumbs(growthCrumbs(...))`. Pursuit record crumbs are FND-18's.
 */ export function growthCrumbs(...tail) {
    return [
        {
            label: 'Home',
            href: '/',
            icon: /*#__PURE__*/ _jsx(Home, {
                className: "h-3 w-3"
            })
        },
        {
            label: 'Growth',
            href: '/growth'
        },
        ...tail
    ];
}
